module.exports = __webpack_public_path__ + "static/img/cover.7012770.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cover.png
// module id = 2DW3
// module chunks = 1